import { render, staticRenderFns } from "./MSecondaryPlanChange.vue?vue&type=template&id=94a29dde&"
import script from "./MSecondaryPlanChange.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryPlanChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports